<template>
  <div
    v-intro="$t('HINTS.PROJECT_HINT_STEP_3')"
    v-intro-step="3"
    v-intro-if="
      hints('project') && card.id == totalCount + 1 && $route.path.length === 4
    "
    class="main__item card card_help"
    :class="{
      helpdone: card.type.key == 3,
      needhelp: card.type.key == 2,
      canhelp: card.type.key == 1
    }"
  >
    <header class="card__main">
      <div class="card__body">
        <a
          :href="
            `${$route.meta.description.to}/post=${+card.id}?page=${currentPage}`
          "
          class="card__title"
        >
          {{ card.name | toCut(35) }}
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.2308 15.0268V17.875C15.2308 18.7499 14.5192 19.4615 13.6442 19.4615H4.125C3.25008 19.4615 2.53846 18.7499 2.53846 17.875V8.35577C2.53846 7.48084 3.25008 6.76923 4.125 6.76923H7.02646L9.56577 4.23077H4.125C1.84631 4.23077 0 6.07708 0 8.35577V17.875C0 20.1537 1.84631 22 4.125 22H13.6442C15.9229 22 17.7692 20.1537 17.7692 17.875V12.4875L15.2308 15.0268Z"
              fill="#484848"
            />
            <path
              d="M19.107 -1.52998e-06H10.4263C8.83046 0.00169078 8.94131 0.431537 9.78323 1.27261L12.5078 3.99723L7.83708 8.66715C6.86823 9.63515 6.86908 11.2039 7.83708 12.1711L9.87631 14.2112C10.8443 15.1766 12.4114 15.1775 13.3794 14.2103L18.0502 9.53954L20.724 12.2134C21.6556 13.1442 21.9992 13.1687 21.9992 11.5728L22 2.893C21.9992 -0.0152326 22.0203 -0.000847684 19.107 -1.52998e-06Z"
              fill="#484848"
            />
          </svg>
        </a>
        <div class="card__author">
          <strong>{{ card.author.trim() }}</strong>
          <span class="card__tag">{{ card.region.name }}</span>
        </div>
        <p class="card__subtitle">{{ card.text }}</p>
      </div>
    </header>

    <footer class="card__extra">
      <div class="card__tags">
        <span class="card__tag">
          <small>
            <i18n path="VUE.AVAILABLE_TIME">
              <template #from>
                <strong>{{ card.avaliable_time.from }}</strong>
              </template>
              <template #to>
                <strong>{{ card.avaliable_time.to }}</strong>
              </template>
            </i18n>
          </small>
        </span>
      </div>
      <div class="card__contact" ref="tooltipPlace">
        <span>
          <strong>{{ $t("CALL_WITH") }}</strong>
        </span>
        <div class="card__links">
          <AuthorPhone wrapper="card" :phone="card.author_phone" />

          <a
            class="card__link"
            target="_blank"
            rel="noreferrer nofollow"
            v-for="({ href, label, icon }, index) in card.contact_types"
            :key="`${href}_${index}`"
            :href="href"
            :title="label"
            :aria-label="label"
          >
            <img :src="icon" :alt="label" />
          </a>
        </div>
        <div class="card__canhelp-tooltip">
          <span>Выберите способы связи ниже</span>
        </div>
      </div>
      <div class="card__footer">
        <div class="card__canhelp" v-if="card.type.key === 2" ref="canhelp">
          <span>Помочь</span>
        </div>
        <div
          class="card__complain"
          @click="
            managePopupState({ popup: 'complainForm', _state: true }),
              getPostId(card.id)
          "
        >
          <span>Пожаловаться</span>
        </div>
        <div
          v-intro="$t('HINTS.PROJECT_HINT_STEP_5')"
          v-intro-step="5"
          v-intro-if="
            hints('project') && card.type.key == 2 && $route.path.length === 4
          "
          v-if="card.type.key === 2"
          class="card__upload"
          @click="
            managePopupState({ popup: 'uploadForm', _state: true }),
              getPostId(card.id)
          "
        >
          <span>{{ $t("HELPED") }}</span>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import AuthorPhone from "@/components/app/AuthorPhone";
import { mapMutations, mapGetters } from "vuex";

export default {
  name: "PostHelp",
  props: {
    card: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapMutations(["managePopupState", "getPostId"]),
    showTooltip({ target }) {
      const button = this.$refs.canhelp,
        tooltip = this.$refs.tooltipPlace;
      target === button
        ? tooltip?.classList.toggle("shown")
        : target !== button &&
          tooltip?.classList.contains("shown") &&
          tooltip?.classList.remove("shown");
    }
  },
  computed: {
    ...mapGetters(["currentPage", "totalCount", "hints"])
  },
  mounted() {
    document.addEventListener("click", this.showTooltip);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.showTooltip);
  },
  components: {
    AuthorPhone
  }
};
</script>

<style lang="scss">
@import "@/assets/_vars";

.card.card_help {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .card {
    &__main {
      flex-direction: column;
    }

    &__body {
      width: 100%;
    }

    &__title {
      position: relative;
      align-items: center;
      justify-content: space-between;
      margin: 0 0 15px;
      font-size: 22px;
      font-weight: $bl_fw;
      line-height: normal;
      color: $prim_c;

      svg {
        min-width: 22px;
        margin: 0 0 0 10px;

        path {
          transition: all 0.2s;
        }
      }

      &:hover {
        path {
          fill: rgba($prim_c, 0.8);
        }
      }
    }

    &__author {
      font-size: 18px;

      span {
        margin: 0 0 0 10px;
      }
    }

    &__tag {
      padding: 5px 15px;
      font-size: 15px;
      background-color: darken($sec_bg, 5%);
      border-radius: 5px;
    }

    &__subtitle {
      position: relative;
      height: 140px;
      margin: 25px 0;
      overflow: hidden;
      color: rgba($prim_c, 0.8);

      &::before {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 40px;
        content: "";
        background: linear-gradient(180deg, rgba(#fff, 0.8), #fff 100%);
        box-shadow: 0 0 10px 10px rgba(#fff, 0.8);
      }
    }

    &__contact {
      position: relative;
      align-items: center;
      margin: 0 0 25px;
      transition: margin 0.2s;

      span {
        margin: 0 10px 0 0;
      }

      &.shown {
        .card__canhelp-tooltip {
          display: block;
        }
      }
    }

    &__phone {
      position: absolute;
      top: 40px;
      left: 50%;
      padding: 5px 10px;
      z-index: 99;
      background-color: #fff;
      border-radius: 10px;
      box-shadow: 0 0 5px 1px rgba($color: #000, $alpha: 0.1);
      transform: translate(-50%, 0);

      a {
        font-weight: $b_fw;
        color: $aux_c;
        white-space: nowrap;
      }

      &::after {
        position: absolute;
        top: -5px;
        left: 50%;
        content: "";
        border-right: 5px solid transparent;
        border-bottom: 5px solid rgba($color: $aux_c, $alpha: 0.5);
        border-left: 5px solid transparent;
      }
    }

    &__link {
      position: relative;
      margin: 0 10px 0 0;
      cursor: pointer;

      img {
        display: inline-block;
        vertical-align: middle;
      }
    }

    &__tags {
      margin: 0 0 20px;
    }

    &__footer {
      flex-wrap: wrap;
    }

    &__canhelp,
    &__complain,
    &__upload {
      position: relative;
      display: flex;
      padding: 5px 10px;
      margin: 5px 0;
      cursor: pointer;
      border-radius: 5px;
      transition: background-color 0.2s;

      span {
        font-size: 14px;
        font-weight: $b_fw;
        color: $sec_c;
        pointer-events: none;
      }
    }

    &__canhelp {
      background-color: #66bb6a;

      &-tooltip {
        position: absolute;
        top: -100%;
        right: 100%;
        display: none;
        padding: 5px 20px;
        background-color: $sec_bg;
        border-radius: 10px;
        box-shadow: 0 0 5px 1px rgba($color: #000, $alpha: 0.1);
        transform: translate(100%, -50%);

        span {
          margin: 0;
          font-weight: $b_fw;
          color: $prim_c;
          white-space: nowrap;
        }

        &::after {
          position: absolute;
          bottom: -8px;
          right: 50%;
          content: "";
          border-left: 5px solid transparent;
          border-top: 5px solid $aux_c;
          border-right: 5px solid transparent;
          transform: translate(50%, -50%);
        }
      }

      &:hover {
        background-color: darken(#66bb6a, 10%);
      }
    }

    &__complain {
      background-color: #ef5350;

      &:hover {
        background-color: darken(#ef5350, 10%);
      }
    }

    &__upload {
      background-color: $aux_bg;

      &:hover {
        background-color: darken($aux_bg, 10%);
      }
    }

    &__tags,
    &__contact,
    &__main,
    &__head,
    &__title,
    &__links,
    &__footer {
      display: flex;
    }

    &__main,
    &__head,
    &__footer {
      align-items: center;
      justify-content: space-between;
    }

    &__main,
    &__extra {
      width: 100%;
    }
  }

  &.needhelp {
    border-top: 5px solid #ef5350;
  }

  &.canhelp {
    border-top: 5px solid $aux_c;
  }

  &.helpdone {
    border-top: 5px solid #66bb6a;
  }
}
</style>
